"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PingbackContext = void 0;
const js_analytics_1 = require("@giphy/js-analytics");
const preact_1 = require("preact");
const hooks_1 = require("preact/hooks");
exports.PingbackContext = (0, preact_1.createContext)({});
const PingbackContextManager = ({ attributes, children }) => {
    const { attributes: parentAttributes = {} } = (0, hooks_1.useContext)(exports.PingbackContext);
    return ((0, preact_1.h)(exports.PingbackContext.Provider, { value: { attributes: (0, js_analytics_1.mergeAttributes)(parentAttributes, attributes, 'layout_type') } }, children));
};
exports.default = PingbackContextManager;
//# sourceMappingURL=pingback-context-manager.js.map